export default __webpack_public_path__ + "static/interior-1026452_1920-14d5e86b31ffa8e372eaf9de2f7196b7.png";